<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default { 
    name: 'component-list',
    computed: {
        children() {            
            let mappedchildren = {};
            for(let child of this.$children) {  
                mappedchildren[child.title] = child;
            }
            return mappedchildren;
        },
        childrenNames() {
            return this.$children;
        }
    },
    mounted() {
        this.$emit('ready');
    },
    methods: {
        select(id) { 
            this.disableAll();
            if(id) {
                this.children[id].enable();
            }
        },
        disableAll() {
            for(let child of this.childrenNames) {
                child.disable();
            }
        }
    }

}
</script>

<style scoped>

</style>